import React, { useState, useRef, useEffect } from "react";
import { useAuth } from "../AuthContext";
import { useNavigate, Link } from "react-router-dom";
import RoleSwitchModal from "./RoleSwitchModal";

function Header() {
  const { user, logout, selectedRole, roles } = useAuth();
  const navigate = useNavigate();
  const [showDropdown, setShowDropdown] = useState(false);
  const [showRoleSwitchModal, setShowRoleSwitchModal] = useState(false);
  const dropdownRef = useRef(null);

  const handleLogout = () => {
    logout();
    navigate("/welcome");
    setShowDropdown(false);
  };

  const formatRoleName = (role) => {
    return role
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  const toggleDropdown = (e) => {
    e.stopPropagation();
    setShowDropdown(!showDropdown);
  };

  const openSettingsModal = (type) => {
    console.log(`Opening ${type} settings`);
    setShowDropdown(false);
  };

  const navigateToAIUsage = () => {
    navigate("/ai-usage");
    setShowDropdown(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };
    
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  return (
    <header className="header">
      <div className="logo">
        <img src="/inpods-logo.png" alt="InPods Logo" id="logo-img" onError={(e) => {
          e.target.style.display = 'none';
          document.getElementById('logo-fallback').style.display = 'block';
        }} />
        <span className="logo-fallback" id="logo-fallback" style={{ display: 'none' }}>
          <span className="logo-in">in</span><span className="logo-pods">pods</span><span className="logo-dot">.</span><span className="logo-ai">ai</span>
        </span>
      </div>
      
      {user ? (
        <div className="user-info" ref={dropdownRef}>
          <span className="notif-bell">🔔</span>
          {selectedRole && (
            <span className="role-badge" title={`Currently viewing as: ${formatRoleName(selectedRole)}`}>
              {formatRoleName(selectedRole)}
            </span>
          )}
          <div 
            className="user-avatar" 
            id="user-avatar-button"
            onClick={toggleDropdown}
          >
            {user.name ? user.name.substring(0, 2).toUpperCase() : "US"}
          </div>
          <div 
            className={`user-dropdown ${showDropdown ? 'active' : ''}`} 
            id="user-dropdown-menu"
            style={{ display: showDropdown ? 'block' : 'none' }}
          >
            <div className="dropdown-header">{user.name || "User"}</div>
            {/* {selectedRole && (
              <div className="dropdown-item role-display">
                Viewing as: <strong>{formatRoleName(selectedRole)}</strong>
              </div>
            )} */}
            <div className="dropdown-divider"></div>
            <div className="dropdown-item" onClick={() => openSettingsModal('profile')}>Profile Settings</div>
            <div className="dropdown-item" onClick={() => openSettingsModal('account')}>Account Settings</div>
            <div className="dropdown-item" onClick={() => openSettingsModal('notifications')}>Notifications</div>
            <div className="dropdown-item" onClick={navigateToAIUsage}>AI Usage</div>
            {roles && roles.length > 1 && (
              <>
                <div className="dropdown-divider"></div>
                <div 
                  className="dropdown-item switch-role-btn"
                  onClick={() => {
                    setShowRoleSwitchModal(true);
                    setShowDropdown(false);
                  }}
                >
                  🔄 Switch Role
                </div>
              </>
            )}
            <div className="dropdown-divider"></div>
            <div className="dropdown-item" onClick={handleLogout}>Logout</div>
          </div>
        </div>
      ) : (
        <div className="auth-buttons">
          <Link to="/login" className="btn btn-outline">Login</Link>
          <Link to="/register" className="btn btn-primary">Register</Link>
        </div>
      )}
      
      <RoleSwitchModal 
        isOpen={showRoleSwitchModal}
        onClose={() => setShowRoleSwitchModal(false)}
      />
    </header>
  );
}

export default Header;
